import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { DeviceBoDtoNBK, DisplayBoDtoNBK, UserKeycloakDtoNBK } from 'src/app/api/nbk';
import { AuthService } from 'src/app/core/auth.service';
import {
  getDeviceImage,
  getDeviceModel,
  InfoDeviceEnum,
  showDeviceInfo
} from 'src/app/core/device.utils';
import { getDisplayName, getTimeZone, KEY_LANGUAGE_STORAGE } from 'src/app/core/utils';
import { NgClass, DatePipe } from '@angular/common';
import { DeviceTypeComponent } from '../type/device-type.component';
import { OnlineDeviceComponent } from '../online/online-device.component';
import { DeviceActionComponent } from '../device-action/device-action.component';
import { FromUTCToLocalePipe } from '../../pipes/from-utcto-locale.pipe';
import { CardHeaderComponent } from 'src/app/layout/card-header/card-header.component';

@Component({
    selector: 'app-device-card',
    templateUrl: './device-card.component.html',
    styleUrls: ['./device-card.component.scss'],
    imports: [NgClass, DeviceTypeComponent, OnlineDeviceComponent, 
      DeviceActionComponent, DatePipe, TranslatePipe, FromUTCToLocalePipe, CardHeaderComponent
    ]
})
export class DeviceCardComponent implements OnInit, OnDestroy {
  @Input() device: DeviceBoDtoNBK;
  @Input() kcUser: UserKeycloakDtoNBK;
  @Output() update: EventEmitter<void> = new EventEmitter();

  unsubscribe$: Subject<void> = new Subject();

  lang: string;
  timezone: string;
  InfoDeviceEnum = InfoDeviceEnum;
  showedInHeader: InfoDeviceEnum;

  constructor(
    public authService: AuthService,
    private ts: TranslateService,
  ) {
    this.lang = localStorage.getItem(KEY_LANGUAGE_STORAGE)!;
    this.timezone = getTimeZone();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  checkIfViewInfo(key: InfoDeviceEnum) {
    return this.showDeviceInfo(key) && key !== this.showedInHeader;
  }

  showDeviceInfo(key: InfoDeviceEnum) {
    return showDeviceInfo(key, this.device.owner === this.kcUser.id && !this.authService.permissions.SERVICE);
  }

  loadDataSource() {
    this.update.emit();
  }

  getImage () {
    return getDeviceImage(this.device, 'family');
  }

  getDisplayName(display: DisplayBoDtoNBK) {
    return getDisplayName(display.constructor!, display.name!, this.ts);
  }

  getDeviceModel() {
    return getDeviceModel(this.device);
  }

  getHeaderTitle() {
    if ( this.showDeviceInfo(InfoDeviceEnum.name) ) {
      this.showedInHeader = InfoDeviceEnum.name;
      return this.device.name
    } else if ( this.showDeviceInfo(InfoDeviceEnum.serial) ) {
      this.showedInHeader = InfoDeviceEnum.serial;
      return this.device.serial;
    } else if ( this.showDeviceInfo(InfoDeviceEnum.hardware) ) {
      this.showedInHeader = InfoDeviceEnum.hardware;
      return this.device.hardwareId;
    } else {
      return '';
    }
  }
  
}
